import { DisplayableField } from '../../base/search/basic-search-result-table/basic-search-result-table.component';

export const displayableFields: DisplayableField[] = [
  {
    value: 'pointOfSaleNames',
    label: 'Point of sale'
  },
  {
    value: 'originNames',
    label: 'First market'
  },
  {
    value: 'destinationNames',
    label: 'Second market'
  },
  {
    value: 'description',
    label: 'Description'
  },
  {
    value: 'ruleStatusActive',
    label: 'Rule status'
  }
];

export const displayableFieldsWithId: DisplayableField[] = [
  {
    value: 'id',
    label: 'Rule ID',
    isSortable: true,
    hasCopyToClipboard: true,
    displayShortened: true
  },
  {
    value: 'name',
    label: 'Name',
    isSortable: true
  },
  {
    value: 'pointOfSaleNames',
    label: 'Point of sale'
  },
  {
    value: 'originNames',
    label: 'First market'
  },
  {
    value: 'destinationNames',
    label: 'Second market'
  },
  {
    value: 'description',
    label: 'Description'
  },
  {
    value: 'ruleStatusActive',
    label: 'Rule status'
  }
];
